import { inject, observer } from '../core/store'
import React from 'react'
import { Layout} from 'antd'
const { Footer } = Layout
@inject('store')
@observer
export default class extends React.Component {
  render() {
    return (
      <Footer style={{textAlign: 'center'}}></Footer>
    )
  }
}



// WEBPACK FOOTER //
// ./layout/Footer.js